import { JSX } from 'react'

// eslint-disable-next-line @typescript-eslint/naming-convention
import Login from '@/components/login.tsx'
// eslint-disable-next-line @typescript-eslint/naming-convention
import Spectrum from '@/components/spectrum.tsx'

// eslint-disable-next-line @typescript-eslint/naming-convention
import Authorize from '@/views/authorize'
// eslint-disable-next-line @typescript-eslint/naming-convention
import Manager from '@/views/manager'
// eslint-disable-next-line @typescript-eslint/naming-convention
import Supervisor from '@/views/supervisor'




export default (): JSX.Element =>
{
	return (
		<Login>
			{dispatch => <Spectrum dispatch={dispatch} authorize={Authorize} manager={<Manager />} supervisor={<Supervisor />} />}
		</Login>

	)

}
